// Import React and required libraries
import React from "react";
import "../styles/GuidePage.css";
import Nav from "../components/nav";
import SEO from '../components/SEO';
import { baseUrl } from '../config';



// Guide Page Component
const GuidePage = () => {
  return (
    <>
    <SEO
      title="Collaborative Ecosystem for Filmmakers"
      description="Discover ProducerBuddy's collaborative features: real-time messaging, community forums, and team productivity tools built for film productions worldwide."
      url="https://producerbuddy.pilomation.com/collaborative-ecosystem"
    />
    <Nav/>
    <div className="guide-page">
      <header className="guide-header">
        <h1>Welcome to the Collaborative Ecosystem</h1>
        <p>Explore features designed to empower your production journey.</p>
      </header>

      <main className="guide-content">
        {/* Section: In-Built Messenger */}
        <section className="feature-section">
          <div className="feature-image">
            <img src="/images/messenger.png" alt="In-Built Messenger" />
          </div>
          <div className="feature-info">
            <h2>In-Built Messenger</h2>
            <p>
              Communicate seamlessly with your team using real-time chat,
              file-sharing, and task-tracking tools.
            </p>
            <button>Learn More</button>
          </div>
        </section>

        {/* Section: Community Page */}
        <section className="feature-section reverse">
          <div className="feature-info">
            <h2>Community for Professionals</h2>
            <p>
              Join a vibrant community of film industry experts to share ideas,
              discuss projects, and collaborate.
            </p>
            <button>Explore Community</button>
          </div>
          <div className="feature-image">
            <img src="/images/community.png" alt="Community Page" />
          </div>
        </section>

        {/* Section: Blog Posting */}
        <section className="feature-section">
          <div className="feature-image">
            <img src="/images/blogs.png" alt="Blog Posting" />
          </div>
          <div className="feature-info">
            <h2>Blog Posting</h2>
            <p>
              Share insights and experiences or learn from top producers'
              inspiring stories and case studies.
            </p>
            <button>Read Blogs</button>
          </div>
        </section>

        {/* Section: Advertisement Collaboration */}
        <section className="feature-section reverse">
          <div className="feature-info">
            <h2>Advertisement Collaboration</h2>
            <p>
              Align production and advertising teams for a streamlined creative
              process with shared tools and templates.
            </p>
            <button>Collaborate Now</button>
          </div>
          <div className="feature-image">
            <img src="/images/ads.png" alt="Ad Collaboration" />
          </div>
        </section>
      </main>

      <footer className="guide-footer">
        <p>&copy; Empowering Film Creators.</p>
      </footer>
    </div>
    </>
  );
};

export default GuidePage;


